import { useQuery } from 'react-query';

import { getHeatMapSBSData } from 'api/InteractiveMap/getHeatMapSBSData';

export const useGetHeatMapSBSData = (planSlug: string, dateStart: string, dateEnd: string) => {
  const { data, refetch, isFetching } = useQuery(
    ['heatMapSBSData', planSlug, dateStart, dateEnd],
    () => getHeatMapSBSData(planSlug, dateStart, dateEnd),
    {
      enabled: !!planSlug && !!dateStart && !!dateEnd,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );

  return { data, refetch, isFetching };
};

export default useGetHeatMapSBSData;
